var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("qr-login-title")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c("w-col", { attrs: { xs: "12" } }, [
                _vm._v(_vm._s(_vm.$ct("qr-login-info"))),
              ]),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c("w-col", { staticClass: "qr-wrapper", attrs: { xs: "12" } }, [
                _c("div", { staticClass: "qr-frame" }, [
                  _vm.isVisible
                    ? _c("img", {
                        staticClass: "qr",
                        attrs: { src: _vm.image, alt: "" },
                      })
                    : _c("div", { staticClass: "qr qr-placeholder" }),
                  !_vm.isVisible
                    ? _c(
                        "div",
                        { staticClass: "qr-overlay" },
                        [
                          _c(
                            "w-button",
                            {
                              attrs: { disabled: _vm.loading },
                              on: {
                                click: function ($event) {
                                  return _vm.showCode()
                                },
                              },
                            },
                            [
                              _c("w-fa", {
                                staticClass: "mr",
                                attrs: { icon: "qrcode" },
                              }),
                              _vm._v(_vm._s(_vm.$ct("qr-login-show")) + " "),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]),
            ],
            1
          ),
          _vm.isVisible
            ? _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { staticClass: "ta-center", attrs: { xs: "12" } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$ct("qr-login-visible-for", {
                            time: _vm.countdown,
                          })
                        )
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.errorMessage
            ? _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-error-message", { attrs: { hide: false } }, [
                        _vm._v(_vm._s(_vm.errorMessage)),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "w-row",
            [
              _c("w-col", { staticClass: "qr-warning", attrs: { xs: "12" } }, [
                _vm._v(_vm._s(_vm.$ct("qr-login-warning"))),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }